import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { categoryService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import CategoryForm from '../components/CategoryForm';
import { ICategoryState } from '../types';

export function EditCategory() {
  const translationPrefix = 'types.categories.new';
  const { categoryId } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [category, setCategory] = useState<ICategoryState>();
  useEffect(() => {
    categoryService.get(+categoryId).then(setCategory);
  }, []);

  const updateCategory = async (values) => {
    dispatch(loadingActions.startLoading());
    const payload = {
      ...values,
      sector:
        values.sector === '' || values.sector === undefined || values.sector === null
          ? null
          : values.sector
    };
    categoryService.update(category.id, payload).then((res) => {
      enqueueSnackbar('Categoria aggiunta con successo');
    });
    dispatch(loadingActions.stopLoading());
  };
  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={category?.code}>
      <CategoryForm category={category} onSubmit={updateCategory} />
    </TenantPage>
  );
}

export default EditCategory;
